import * as React from "react";
const SvgConsol20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 2h20v16H0V2Zm2 2v12h16V4H2Zm3 1.086.707.707 2 2 .707.707-.707.707-2 2-.707.707L3.586 10.5l.707-.707L5.586 8.5 4.293 7.207 3.586 6.5 5 5.086ZM10 9.5H9v2h5v-2h-4Z",
      clipRule: "evenodd"
    })
  );
export default SvgConsol20Px;
